export default __webpack_public_path__ + "static/media/thalamus_mask.40d616fa.png";